export default {
      id: "ic_bell_white-usage",
      viewBox: "0 0 28 28",
      url: "/" + "images/icons.3.109.2.svg#ic_bell_white-usage",
      toString: function () {
        return this.url;
      }
    }